import { ContainerModule } from 'inversify';
import SocketConnection from '@framework/di/Providers/Socket/Connection';
import { ISocketAdapter, ISocketClient, ISocketDispatcher } from './interfaces';
import DITypes from './types';
import { SocketAdapter } from '../SocketAdapter';
import { SocketDispatcher } from '../SocketDispatcher';
import SocketClient from '../SocketClient';
import { ISocketConnection } from './interfaces';

export const SocketModule = new ContainerModule(({ bind }) => {
  bind<ISocketConnection>(DITypes.SocketConnection).to(SocketConnection).inSingletonScope();

  bind<ISocketAdapter>(DITypes.SocketAdapter).to(SocketAdapter).inSingletonScope();

  bind<ISocketDispatcher>(DITypes.SocketDispatcher).to(SocketDispatcher).inSingletonScope();

  bind<ISocketClient>(DITypes.SocketClient).to(SocketClient).inSingletonScope();
});
